"use client";

import React from "react";
import SoftAlert from "./SoftAlert";
import LoudAlert from "./LoudAlert";
import { AlertPropTypes } from "./types";
export { validTypeValues, validVariationValues, validBackgroundValues } from "./types";
var Alert = function Alert(props) {
  if (props.variation === "soft") {
    return /*#__PURE__*/React.createElement(SoftAlert, props);
  }
  return /*#__PURE__*/React.createElement(LoudAlert, props);
};
Alert.displayName = "Alert";
export default Alert;